import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc8cb898"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "dat-protocol",
  class: "section"
}
const _hoisted_2 = { class: "section-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "emphasis" }, "Synchronizing", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "emphasis" }, "Ledgers", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dat-acronym" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "emphasis" }, "Decentralized"),
  /*#__PURE__*/_createElementVNode("h2", { class: "emphasis" }, "Asset"),
  /*#__PURE__*/_createElementVNode("h2", { class: "emphasis" }, "Transfer")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Description = _resolveComponent("Description")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.header), 1),
    _createVNode(_component_Description, {
      text: _ctx.desc1.text,
      image: _ctx.desc1.image,
      position: _ctx.desc1.position
    }, null, 8, ["text", "image", "position"]),
    _hoisted_3,
    _hoisted_4,
    _createVNode(_component_Description, {
      text: _ctx.desc2.text,
      image: _ctx.desc2.image,
      position: _ctx.desc2.position
    }, null, 8, ["text", "image", "position"]),
    _hoisted_5
  ]))
}